/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from "react";

//import { isMobile } from "../../components/breakpoints";

//import SlidingPanel from "react-sliding-side-panel";

import { IEshopOrderSummaryViewProps } from "./eshop-order-summary";
import { ArrayExtensions } from '@msdyn365-commerce-modules/retail-actions';
import { Button } from '@msdyn365-commerce-modules/utilities';
import { AsyncResult, CartLine, SimpleProduct } from '@msdyn365-commerce/retail-proxy';
import { validateForCheckoutAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/CartsDataActions.g';
import { ICartState } from '@msdyn365-commerce/global-state';

import { deleteBTGPCartLineAsync } from '../../actions/DataActionExtension.g';
import { generateErrorLog } from '../../actions/helper-functions';
import { FormDetails } from '../../actions/ecomm-interfaces';

interface IDimensionStrings {
  /** String for size key  */
  sizeString?: string;
  /** String for color key  */
  colorString?: string;
  /** String associated with the configuration product dimension  */
  configString?: string;
  /** String for style key  */
  styleString?: string;
  /** String for amount key  */
  amountString?: string;
}

export class OrderSummaryView extends React.PureComponent<
  IEshopOrderSummaryViewProps
> {
  public state: any = { hasMounted: false, openPanel: false, width: 0 };

  public componentDidMount(): void {
    if (!this.state.hasMounted) {
      window.addEventListener("resize", this._updateDimensions);

      this.setState({ hasMounted: true, width: window.innerWidth });
    }
  }

  public render(): JSX.Element | null {
    if (!this.state.hasMounted) {
      return null;
    }
    const { cart, products } = this.props;

    // if (this.props.config.enableMobile) {
    //   return isMobile(this.state.width) ? this._renderMobile() : null;
    // } else {
    //   if (isMobile(this.state.width)) {
    //     return null;
    //   }

      const bg = this.props.config.orderSummaryImage?.src
        ? { backgroundImage: `url(${this.props.config.orderSummaryImage.src})` }
        : { backgroundImage: "" };

      return (
        <div className="eshop-order-confirm-summary row">
          <div className="summary col-12" style={bg}>
            <h5 className="header">{this.props.config.orderSummaryHeaderText}</h5>
            {products && cart && cart.CartLines ? this._getCartItems() : null}
            <div className="summary-footer">
            <hr className="line-end" />
            <div className="total">
              {this.props.config.totalText}
              {cart ? " " + "$" + cart.SubtotalAmount : ""}
            </div>
            <hr className="line-end" />
            <div className="container">
            <div className="summary-button-wrapper row">
            <Button
                    className="eshop-cart-button col-5" onClick={(event) => {
                      event.preventDefault();
            
                      if (this.props.config.gotoCartUrl) {
                        window.location.href = this.props.config.gotoCartUrl;
                      }
                    } } aria-label={this.props.config.gotoCartText}
               >
                    {this.props.config.gotoCartText}
                </Button>
                <Button
                    className="eshop-checkout-button col-5" onClick={(event) => {
                      event.preventDefault();
            
                      if (this.props.config.gotoCheckoutUrl) {
                        window.location.href = this.props.config.gotoCheckoutUrl;
                      }
                    } } aria-label={this.props.config.gotoCheckoutText}
               >
                    {this.props.config.gotoCheckoutText}
                </Button>
            </div>
            </div>
            </div>
          </div>
        </div>
      );
    // }
  }

  public componentWillUnmount() {
    window.removeEventListener("resize", this._updateDimensions);
  }

  private _getCartItems(): JSX.Element[] | null {
    const { cart, products } = this.props;

   const destructDimensionStrings = {
    sizeString: this.props.config.SizeDimension,
    colorString: this.props.config.colorDimension,
    styleString: this.props.config.styleDimension,
    configString: this.props.config.configDimension,
    amountString: this.props.config.amountDimension
};

    return cart.CartLines!.map((item, index) => {
      const productDimensions = products[`${index}`] && this.CartLineItemFunctions.renderProductDimensions(products[`${index}`], destructDimensionStrings);
      return (
        <div className="item row">
          <div className="col-4">
            <img src={products[`${index}`].PrimaryImageUrl}></img>
          </div>
          <div className="col-7 item-content row">
            <p className="col-12 item-name">
              <p className="row">{products[`${index}`].Name}</p>
              <p className="row item-price">
                {" "}
                {"$" + item.Price! * item.Quantity!}
              </p>
              {ArrayExtensions.hasElements(productDimensions) ? <p className='item-price'>{productDimensions}</p> : ''}
              <p className="row item-price">{this.props.config.QuantityText ? this.props.config.QuantityText : "Quantity" }: {item.Quantity!}</p>
              <p className="row remove-button-wrapper">
              <button className='remove-button' onClick={() => this.removeItem(item, this.props)}>{this.props.config.removeButtontext}</button>
             </p>
            </p>
          </div>
        </div>
      );
    });
  }

  // private _getMobileCartItems(): JSX.Element[] | null {
  //   const { cart, products } = this.props;

  //   return cart.CartLines!.map((item, index) => {
  //     return (
  //       <div className="line-item row">
  //         <div className="product col-10 col-sm-11">
  //           {products[`${index}`].Name}
  //         </div>
  //         <div className="information col-2 col-sm-1">
  //           ${item.Price! * item.Quantity!}
  //         </div>
  //       </div>
  //     );
  //   });
  // }

  // private _renderMobile(): JSX.Element | null {
  //   const { cart } = this.props;

  //   const bg = this.props.config.orderSummaryImage?.src
  //     ? { backgroundImage: `url(${this.props.config.orderSummaryImage.src})` }
  //     : { backgroundImage: "" };

  //   return (
  //     <div className="ecomm-order-summary mobile">
  //       <div className="banner row" style={bg}>
  //         <div className="col-4">
  //           <div>
  //             <p className="msc-order-summary__line-total">
  //               <span className="msc-order-summary__label">
  //                 {this.props.config.totalText}
  //               </span>
  //               <span className="msc-price msc-order-summary__value">
  //                 <span className="msc-price__actual">
  //                   ${cart && cart.TotalAmount?.toFixed(2)}
  //                 </span>
  //               </span>
  //             </p>
  //           </div>
  //         </div>
  //         <button className="toggle col-8" onClick={this._onTogglePanel}>
  //           {this.props.config.openMobilePanelTitle}
  //         </button>
  //       </div>
  //       <SlidingPanel
  //         type={"right"}
  //         isOpen={this.state.openPanel}
  //         size={50}
  //         backdropClicked={this._onTogglePanel}
  //       >
  //         {this.state.openPanel && (
  //           <div className="content" style={bg}>
  //             <p className="header">
  //               {this.props.config.orderSummaryHeaderText}
  //             </p>
  //             {cart && this._getMobileCartItems()}
  //             <div className="line-tax row">
  //               <div className="col-6">{this.props.config.taxTitle}</div>
  //               <div className="information col-6">
  //                 {this.props.config.taxStatusTitle}
  //               </div>
  //             </div>
  //             <hr className="line-end" />
  //             <div className="msc-order-summary">
  //               <div>
  //                 <p className="msc-order-summary__line-total">
  //                   <span className="msc-order-summary__label">
  //                     {this.props.config.totalText}
  //                   </span>
  //                   <span className="msc-price msc-order-summary__value">
  //                     <span className="msc-price__actual">
  //                       ${cart && cart.TotalAmount?.toFixed(2)}
  //                     </span>
  //                   </span>
  //                 </p>
  //               </div>
  //             </div>
  //           </div>
  //         )}
  //       </SlidingPanel>
  //     </div>
  //   );
  // }

  // private _onTogglePanel = () => {
  //   this.setState({ openPanel: !this.state.openPanel });
  // };

  private _updateDimensions = () => {
    this.setState({ width: window.innerWidth });
  };
  public removeItem = async(cartlineToRemove: CartLine, props: IEshopOrderSummaryViewProps)=> {
  
    if (props.cart) {
      const childCartLineData = props.cart.CartLines?.filter(cl => cl['ParentCartLineID'] === cartlineToRemove.LineId);
      let cartLinesToRemove = [cartlineToRemove.LineId!];
  
      childCartLineData||[].map((child) => {
        cartLinesToRemove.push(child['CartLineID']);
      });
  
      const input = { cartLineIds: cartLinesToRemove };
  
      await this.props.cartItems.removeCartLines(input)
        .catch((error) => {
          props.telemetry.warning(error);
          props.telemetry.debug('Unable to Remove Cart Line');
        });
  
      await this.validateCart(props)
        .catch((error) => {
          props.telemetry.warning(error);
          props.telemetry.debug('Unable to validate Cart');
        });
  
      await deleteBTGPCartLineAsync({ callerContext: props.context.actionContext }, cartlineToRemove.LineId!);

      this.props.callbacks.updateCartState(!this.state.openPanel);
      this.setState({openPanel: !this.state.openPanel});
     
      
    }
    const logDetail = 'Capturing user actions, File: eshop-order-summary.View.tsx, funtion: removeItem';
    const item: FormDetails = {
      CartLineID: cartlineToRemove.LineId!, CartID: props.cart.Id, CartLineComment: '', ParentCartLineID: '',
      ProductID: cartlineToRemove.ItemId || '', EventID: '', EventName: '',
      SerialID: '', SerialNumber: cartlineToRemove.Quantity?.toString() || '', SerialName: '',
      Name_1: '', Name_2: '', Name_3: '', Name_4: '', Name_5: '', Name_6: '', Name_7: '', Name_8: '', Name_9: '', Name_10: '', 
      Name_11: '', Name_12: '', Name_13: '', Name_14: '', Name_15: '', Name_16: '', Name_17: '', Name_18: '', Name_19: '', Name_20: '',
      Remarks: '', Message: '',
      Category: '', DedicatedBy: '',
      HasTaxDeduction: false, Nric: '',
      BuildingName: '', UnitNumber: '', PostalCode: '', PhoneNumber: '', Country: '',
      ChineseName:'',
      SchoolName: '', CompanyName: '',
      DonationOption: '', BlessingOption: '', LightOption: '',
      ValidFrom: '', ValidTo: '',
      DedicationPeriod: '',
      StartDate: '',
      Gender: '',
      SurgeryDate: '',
      BirthDate: '', BirthTime: '',
      BirthDate_2: '', BirthTime_2: '',
      DeathDate: '', DeathTime: '',
      DeceasedRelationship: '',
      NameChange: '', OldName_1: '', OldName_2: '',
      NameNextKin:'',
      ContactNumber:'',
      ContactNumberNextKin:'',
      PassportNumber:'',
      PassportExpiryDate:'',
      PassportIssuedDate:'',
      Consent:0,
      IsInsuranceIncluded:0
    };
    await generateErrorLog(props.context, "User clicked Remove button in eShop pdp page", logDetail, item);
  }

  public validateCart = async(props: IEshopOrderSummaryViewProps, retry: boolean = true): Promise<void> =>{
    // if (!this.isQuantityLimitsFeatureEnabled) {
    //     return AsyncResult.resolve();
    // }
  
    const { cartItems } = props;
  
    let cartResult: ICartState;
  
    try {
      cartResult = await cartItems;
    } catch (error) {
      const msg = error as unknown as string;
  
      props.telemetry.warning(msg);
      props.telemetry.debug('Unable to get cart');
  
      return AsyncResult.resolve();
    }
  
    const cartVersion = cartResult.cart?.Version;
  
    if (cartVersion) {
      try {
        await validateForCheckoutAsync({ callerContext: props.context.actionContext }, cartResult?.cart?.Id, cartVersion);
        // this.setState({cartlinesErrors: validationResult.ValidationFailuresByCartLines || []});
        return AsyncResult.resolve();
      } catch (error) {
        const msg = error as unknown as any;
  
        if (retry && msg.name === 'Microsoft_Dynamics_Commerce_Runtime_InvalidCartVersion') {
          try {
            await cartResult.refreshCart({});
          } catch (refreshError) {
            const msg = refreshError as unknown as string;
  
            props.telemetry.warning(msg);
            props.telemetry.debug('Unable to refresh Cart');
  
            return AsyncResult.resolve();
          }
          try {
            await this.validateCart(props, false);
  
            return AsyncResult.resolve();
          } catch (validateError) {
            const msg = validateError as unknown as string;
  
            props.telemetry.warning(msg);
            props.telemetry.debug('Unable to validate Cart');
  
            return AsyncResult.resolve();
          }
        }
  
        props.telemetry.warning(msg);
        props.telemetry.debug('Unable to validate Cart');
  
        return AsyncResult.resolve();
      }
    } else {
      props.telemetry.warning('Cart version not found for Cart validation request.');
  
      return AsyncResult.resolve();
    }
  }

  public CartLineItemFunctions = {
    renderProductDimensions: (Product: SimpleProduct, DimensionStrings: IDimensionStrings) => {
        if (!Product || !Product.Dimensions) {
            return [];
        }

        return Product.Dimensions.map(productDimension => {

            if (productDimension.DimensionTypeValue === 1) {
                return (
                    <div key={`${Product.RecordId}ProductDimensions1`} className='msc-cart-line__product-variant-item'>
                        <span className='msc-cart-line__product-variant-color'>{DimensionStrings.colorString}: <span className='name'>{productDimension.DimensionValue && productDimension.DimensionValue.Value}</span></span>
                    </div>
                );
            }

            if (productDimension.DimensionTypeValue === 2) {
                return (
                    <div key={`${Product.RecordId}ProductDimensions2`} className='msc-cart-line__product-variant-item'>
                        <span className='msc-cart-line__product-configuration'>{DimensionStrings.configString}: <span className='name'>{productDimension.DimensionValue && productDimension.DimensionValue.Value}</span></span>
                    </div>
                );
            }

            if (productDimension.DimensionTypeValue === 3) {
                return (
                    <div key={`${Product.RecordId}ProductDimensions3`} className='msc-cart-line__product-variant-item'>
                        <span className='msc-cart-line__product-variant-size'>{DimensionStrings.sizeString}: <span className='name'>{productDimension.DimensionValue && productDimension.DimensionValue.Value}</span></span>
                    </div>
                );
            }

            if (productDimension.DimensionTypeValue === 4) {
                return (
                    <div key={`${Product.RecordId}ProductDimensions4`} className='msc-cart-line__product-variant-item'>
                        <span className='msc-cart-line__product-variant-style'>{Product.IsGiftCard ? DimensionStrings.amountString : DimensionStrings.styleString}: <span className='name'>{productDimension.DimensionValue && productDimension.DimensionValue.Value}</span></span>
                    </div>
                );
            }
            return null;
        });
    }
};
}


export default OrderSummaryView;
